import { createCachedSelector, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { selectedSymbolGroupsSelector } from '@cbridge-packages/symbol-groups';

export const coreSymbolGroupPropsSelector = createCachedSelector(
  [
    selectedSymbolGroupsSelector,
    prop<{ symbolGroup: string }>().symbolGroup(),
  ],
  (selectedSymbolGroups, symbolGroup) => {
    return selectedSymbolGroups.includes(symbolGroup);
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ symbolGroup: string }>().symbolGroup(),
});
